import React from 'react';
import { useAppSelector } from '../../../../store/hooks';
import { selectBreakawayHull } from '../../../../store/selectors/breakawayHullSelectors';

interface SectionTabsProps {
  activeSectionId: string;
  onSectionChange: (sectionId: string) => void;
}

export const SectionTabs: React.FC<SectionTabsProps> = ({
  activeSectionId,
  onSectionChange,
}) => {
  const breakawayHull = useAppSelector(selectBreakawayHull);

  if (!breakawayHull.isBreakaway || !breakawayHull.sections.length) {
    return null;
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-6">
      {/* Section Tabs */}
      <div className="flex border-b border-gray-200 dark:border-gray-600">
        {breakawayHull.sections.map((section) => (
          <button
            key={section.id}
            onClick={() => onSectionChange(section.id)}
            className={`flex-1 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
              activeSectionId === section.id
                ? 'border-indigo-500 text-indigo-600 dark:text-indigo-400 bg-indigo-50 dark:bg-indigo-900/30'
                : 'border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          >
            <div className="text-center">
              <div className="font-semibold">{section.name}</div>
              <div className="text-xs text-gray-500 dark:text-gray-400">{section.size} tons</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}; 